import { useCallback, useMemo } from 'react';
import { bindActionCreators } from 'redux';
import { useDispatch } from 'react-redux';

import { wrapPromise } from '../../../utils/promise';
import { removeParcelsActionCreators } from '../../../store/actions/ui/routeDetail/removeParcels';
import modals from '../../../enums/modals';
import { startScheduleRoute } from '../../../store/actions/schedule';
import { setScheduleRequired } from '../../../store/reducers/route';
import useSummaryModalData from './useSummaryModalData';
import { useModalContext } from '../../../components/ModalControlled/ModalProvider';

const useRemoveParcelsModalData = () => {
  const dispatch = useDispatch();
  const { getModalRef } = useModalContext();
  const { openSummaryModal } = useSummaryModalData();

  const { onMove, getAffectedStops } = useMemo(
    () => bindActionCreators(removeParcelsActionCreators, dispatch),
    [dispatch]
  );

  const openRemoveParcelsModal = useCallback(async () => {
    const removeParcelsModalRef = getModalRef(modals.REMOVE);
    const [result = {}, canceled] = await wrapPromise(
      removeParcelsModalRef.current.showModal({ onMove, getAffectedStops })
    );
    if (canceled) {
      return;
    }
    const { optimise, transferOnly } = result;
    if (!transferOnly) {
      dispatch(startScheduleRoute(optimise));
    } else {
      dispatch(setScheduleRequired(true));
      openSummaryModal({ isTransfer: false });
    }
  }, [onMove, getAffectedStops, openSummaryModal, dispatch]);

  return {
    openRemoveParcelsModal,
  };
};

export default useRemoveParcelsModalData;
